import { useState } from 'react';

export type TouchedState = { [key in string]: boolean };

export const useTouchedFields = (): [TouchedState, (key: string | string[]) => void] => {
  const [touched, setTouched] = useState<TouchedState>({});

  const updateTouchedFields = (key: string | string[]) => {
    setTouched((prev) => {
      const keys = Array.isArray(key) ? key : [key];
      const updates = keys.reduce((acc, k) => ({ ...acc, [k]: true }), {});

      return {
        ...prev,
        ...updates,
      };
    });
  };

  return [touched, updateTouchedFields];
};
